import {Code, default as BaseApiClient} from './base'
import axios from 'axios'
import LoadingManager from '../utils/loading'
import CommonUtil from '../utils/common'
import {WEB_BASE_URL} from '../defines/api'


export let DataCollectionDownloadParam = {
  categoryId: null,
  filters: null
}

export let PostDataCollectionDownloadParam = Object.assign({

}, DataCollectionDownloadParam)


export let GetDataCollectionCorporationsResult = {
  columns: {},
  data: {}
}

export let GetDataCollectionCorporationDetailResult = {
  columns: {},
  data: {}
}

export default class WebApiClient extends BaseApiClient {
  static BASE_URL = WEB_BASE_URL

  static onInterceptRequest (config) {

    const context = config.context
    config = super.onInterceptRequest(config)

    const skyfoxUrl = window
      ? window.location.pathname + window.location.hash
      : ''
    let headers = {
      'SkyFox-URL': skyfoxUrl,
      'X-Requested-With': 'XMLHttpRequest'
    }

    if (config.url !== 'login/') {
      headers = Object.assign(headers, {
        'Authorization': `Token ${context.$session.get('AUTH_TOKEN')}`
      })
    }

    config.headers = Object.assign(config.headers || {}, headers)

    return config
  }

  static login (context, params) {
    return WebApiClient.post(context, 'login', params, {})
  }

  static logout (context, params) {
    return WebApiClient.post(context, 'logout', params, {})
  }

  static getModels (context) {
    return WebApiClient.get(context, 'models')
  }

  static deleteModel (context, modelId) {
    return WebApiClient.delete(context, `models/${modelId}`)
  }

  static getModel (context, modelId, restrictions) {
    return WebApiClient.get(context, `models/${modelId}`)
  }

  static postModels (context, params) {
    return WebApiClient.post(context, 'models', params, {
      loadingMessage: 'モデル作成中...'
    })
  }

  static putModel (context, modelId, params) {
    return WebApiClient.put(context, `models/${modelId}`, params, {
      loadingMessage: 'モデル更新中...'
    })
  }

  static putModelName (context, modelId, newName) {
    return WebApiClient.put(context, `models/${modelId}`, {
      modelName: newName,
      isRename: true
    })
  }

  static putAllDataModel (context, modelId, params) {
    return WebApiClient.put(context, `models/${modelId}`, params)
  }

  static postModelPredict (context, modelId, params) {
    return WebApiClient.post(context, `models/${modelId}/predictions`, params, {
      loadingMessage: 'モデル適用中...'
    })
  }

  static postModelsCopy (context, modelId) {
    return WebApiClient.post(context, `models/${modelId}/copy`, null, {
      loadingMessage: 'モデルコピー中...'
    })
  }

  static getModelPredictResultList (context, modelId) {
    return WebApiClient.get(context, `models/${modelId}/predictions`)
  }

  static postModelPredictEvaluation (context, modelId, params) {
    return WebApiClient.post(context, `models/${modelId}/predict-evaluations`,
      params, {
        loadingMessage: '適用結果の評価中...'
      })
  }

  static getModelPredictEvaluations (context, modelId) {
    return WebApiClient.get(context, `models/${modelId}/predict-evaluations`)
  }

  static deleteModelError (context, params) {
    return WebApiClient.delete(context, 'models/error/', params)
  }

  static postFigures (context, params, cancelable = false) {
    const source = cancelable ? axios.CancelToken.source() : null
    LoadingManager.show(context, cancelable ? 'サマリ作成中...' : null, source)
    return WebApiClient.post(context, 'figures', params, {
      loading: false,
      cancelToken: source ? source.token : null,
      retryRequest: false
    }).then(this.onInterceptFigureResponse).catch((error) => {
      LoadingManager.hide(context)
      return Promise.reject(error)
    })
  }

  static getFigure (context, figureId, cancelToken, retryRequest = false) {
    if (!retryRequest && context) {
      LoadingManager.show(context)
    }
    return WebApiClient.get(context, `figures/${figureId}`, null, {
      loading: false,
      cancelToken: cancelToken == null ? null : cancelToken,
      retryRequest: retryRequest
    }).then(this.onInterceptFigureResponse).catch((error) => {
      LoadingManager.hide(context)
      return Promise.reject(error)
    })
  }

  static getTransformers (context, categoryId) {
    return WebApiClient.get(context, 'transformers', {
      categoryId: categoryId
    })
  }

  static getTransformerPackages (context, categoryId, packageId = null) {
    return WebApiClient.get(context, `transformers/packages/${categoryId}`, {
      packageId: packageId
    })
  }

  static getTransformerHyperParams (context, transformerId) {
    return WebApiClient.get(context,
      `transformers/${transformerId}/hyper-params`)
  }

  static getAlgorithms (context, categoryId, includeAlgorithm) {
    let params = {
      categoryId: categoryId
    }
    if (CommonUtil.isNotEmpty(includeAlgorithm)) {
      params = Object.assign(params, {
        includeAlgorithm: includeAlgorithm
      })
    }
    return WebApiClient.get(context, 'algorithms', params)
  }

  static getAlgorithmHyperParams (context, algorithmId) {
    return WebApiClient.get(context, `algorithms/${algorithmId}/hyper-params`)
  }

  static getSupportCategories (context) {
    return WebApiClient.get(context, 'support_categories')
  }

  static getSupports (context) {
    return WebApiClient.get(context, 'supports')
  }

  static postSupports (context, params, attachments) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(params))
    if (CommonUtil.isNotEmpty(attachments)) {
      for (const attachment of attachments) {
        formData.append('files', attachment.raw, attachment.name)
      }
    }

    return WebApiClient.post(context, 'supports', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static getSupportCommunications (context, supportId) {
    return WebApiClient.get(context, `supports/${supportId}/communications`)
  }

  static postSupportCommunications (context, supportId, params, attachments) {
    const formData = new FormData()
    formData.append('data', JSON.stringify(params))
    if (CommonUtil.isNotEmpty(attachments)) {
      for (const attachment of attachments) {
        formData.append('files', attachment.raw, attachment.name)
      }
    }

    return WebApiClient.post(context, `supports/${supportId}/communications`,
      formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
  }

  static putSupport (context, supportId, params) {
    return WebApiClient.put(context, `supports/${supportId}`, params)
  }

  static postSupportAttachmentPreSignedUrl (
    context, supportId, communicationId, attachmentId) {
    return WebApiClient.post(context,
      `supports/${supportId}/communications/${communicationId}/attachments/${attachmentId}`)
  }

  static getNotifications (context, onlyIsNewInfo = true) {
    return WebApiClient.get(context, 'notifications', {
      onlyIsNewInfo: onlyIsNewInfo
    })
  }

  static getAccount (context, userId) {
    return WebApiClient.get(context, `accounts/${userId}`)
  }

  static putAccountPassword (context, userId, params) {
    return WebApiClient.put(context, `accounts/${userId}/password`, params)
  }

  static getRentPrefCities (context, modelId) {
    return WebApiClient.get(context, `rent_pref_models/${modelId}/pref_cities`)
  }

  static getInformations (context) {
    return WebApiClient.get(context, 'informations')
  }

  static getDataCollection (context, dataCollectionId, params) {
    // This function covers data collection without company and prefecture data.
    return WebApiClient.get(context, `data-collections/${dataCollectionId}`,
      params)
  }

  static getPrefectures (context) {
    return WebApiClient.get(context, `prefectures`)
  }

  static getDataCollectionDownload (context, dataCollectionId, params) {
    // This function covers data collection without company and prefecture data.
    return WebApiClient.get(context,
      `data-collections/${dataCollectionId}/downloads`, params)
  }

  static postDataCollectionDownload (context, dataCollectionId, params) {
    // This function covers data collection without company and prefecture data.
    return WebApiClient.post(context,
      `data-collections/${dataCollectionId}/downloads`, params, {
        responseType: 'blob'
      })
  }

  static getDataCollectionCorporations (context, params) {
    return WebApiClient.get(context, `data-collections/corporations`, params)
  }

  static getDataCollectionCorporation (context, corpCode, param) {
    return WebApiClient.get(context,
      `data-collections/corporations/${corpCode}`, param, {
        loadingMessage: '詳細データ収集中...'
      })
  }

  static postDataCollectionCorporationDownload (context, corpCode, param) {
    return WebApiClient.post(context,
      `data-collections/corporations/${corpCode}/download`, param, {
        responseType: 'blob'
      })
  }

  static postDataCollectionJoin (
    context, dsName, params, cancelable = false, source = null) {
    // This function covers data collection without company.
    return WebApiClient.post(context, `ds/${dsName}/join/data-collections`,
      params, {
        loading: false,
        cancelToken: source ? source.token : null
      })
  }

  static getDataCollectionPossibilities (context, dsName) {
    return WebApiClient.get(context, `ds/${dsName}/possibilities`)
  }

  static getUploadFiles (context, dsName) {
    return WebApiClient.get(context, `ds/${dsName}/upload-files`)
  }

  static postDsDropColumns (context, dsName, params) {
    // This function covers data collection without company.
    return WebApiClient.post(context, `ds/${dsName}/drop-column/`, params)
  }

  static getDataCollectionSubset (context, dataCollectionId, params) {
    return WebApiClient.get(context,
      `data-collections/${dataCollectionId}/subsets`, params)
  }

  static getConverts (context, params) {
    return WebApiClient.get(context, `converts`, params)
  }

  static postConverts (context, params) {
    return WebApiClient.post(context, `converts`, params, {
      loadingMessage: 'データ変換中...'
    })
  }

  static getConvertResultList (context, params) {
    return WebApiClient.get(context, `converts/results`, params)
  }

  static deleteTask (context, taskId) {
    return WebApiClient.delete(context, `tasks/${taskId}`)
  }

  static postEvaluationPreSignedUrl (context, dsName) {
    return WebApiClient.post(context, `evaluations/${dsName}`)
  }

  static getRestriction (context, restrictionType) {
    return WebApiClient.get(context, `restrictions/${restrictionType}`)
  }

  static checkRestriction (context, next, restrictionType) {
    this.getRestriction(context, restrictionType).then((response) => {
      if (response.data.code === Code.SUCCESS) {
        next()
      } else if ([
        Code.MODEL_USAGE_LIMIT_HAS_BEEN_REACHED,
        Code.API_USAGE_LIMIT_HAS_BEEN_REACHED,
        Code.STORAGE_USAGE_LIMIT_HAS_BEEN_REACHED].indexOf(
        response.data.code) >= 0) {
        next({
          name: 'restrictions-error',
          params: {
            code: response.data.code
          }
        })
      } else {
        next({
          name: 'error',
          params: {
            code: response.data.code
          }
        })
      }
    }).catch(() => {})
  }

  static getConnections (context) {
    return WebApiClient.get(context, 'connections')
  }

  static getConnection (context, connectionId) {
    return WebApiClient.get(context, `connections/${connectionId}`)
  }

  static postConnections (context, params) {
    const copyParams = Object.assign({}, params)
    const sslCertFile = copyParams.sslCertFile
    const sslKeyFile = copyParams.sslKeyFile
    const sslCaFile = copyParams.sslCaFile
    const privateKeyFile = copyParams.privateKeyFile
    delete copyParams.sslCertFile
    delete copyParams.sslKeyFile
    delete copyParams.sslCaFile
    delete copyParams.privateKeyFile
    delete copyParams.sslEnabled

    const formData = new FormData()
    formData.append('data', JSON.stringify(copyParams))

    if (CommonUtil.isNotEmpty(sslCertFile)) {
      formData.append('ssl_cert_file', sslCertFile[0].raw, sslCertFile[0].name)
    }
    if (CommonUtil.isNotEmpty(sslKeyFile)) {
      formData.append('ssl_key_file', sslKeyFile[0].raw, sslKeyFile[0].name)
    }
    if (CommonUtil.isNotEmpty(sslCaFile)) {
      formData.append('ssl_ca_file', sslCaFile[0].raw, sslCaFile[0].name)
    }
    if (CommonUtil.isNotEmpty(privateKeyFile)) {
      formData.append('private_key_file', privateKeyFile[0].raw,
        privateKeyFile[0].name)
    }

    return WebApiClient.post(context, 'connections', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static putConnection (context, connectionId, params) {
    const copyParams = Object.assign({}, params)
    const sslCertFile = copyParams.sslCertFile
    const sslKeyFile = copyParams.sslKeyFile
    const sslCaFile = copyParams.sslCaFile
    const privateKeyFile = copyParams.privateKeyFile
    delete copyParams.sslCertFile
    delete copyParams.sslKeyFile
    delete copyParams.sslCaFile
    delete copyParams.privateKeyFile
    delete copyParams.sslEnabled

    const formData = new FormData()
    formData.append('data', JSON.stringify(copyParams))

    if (CommonUtil.isNotEmpty(sslCertFile)) {
      formData.append('ssl_cert_file', sslCertFile[0].raw, sslCertFile[0].name)
    }
    if (CommonUtil.isNotEmpty(sslKeyFile)) {
      formData.append('ssl_key_file', sslKeyFile[0].raw, sslKeyFile[0].name)
    }
    if (CommonUtil.isNotEmpty(sslCaFile)) {
      formData.append('ssl_ca_file', sslCaFile[0].raw, sslCaFile[0].name)
    }
    if (CommonUtil.isNotEmpty(privateKeyFile)) {
      formData.append('private_key_file', privateKeyFile[0].raw,
        privateKeyFile[0].name)
    }

    return WebApiClient.put(context, `connections/${connectionId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  static deleteConnection (context, connectionId) {
    return WebApiClient.delete(context, `connections/${connectionId}`)
  }

  static onInterceptFigureResponse (response) {
    return new Promise((resolve, reject) => {
      if (response.status === 200) {
        const data = response.data
        const config = response.config
        const context = config.context

        if (data.code === Code.TIMEOUT) {
          setTimeout(() => {
            WebApiClient.getFigure(context, data.result.figureId,
              response.config.cancelToken, true).then(resolve, reject)
          }, 3000)
          return
        } else {
          if (context) {
            LoadingManager.hide(context)
          }
          resolve(response)
          return
        }
      }

      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/web.js